//node_modules
import urlJoin from "proper-url-join";

const WEBSITE_DOMAIN = "https://www.adjusttothegoodlifetravel.com/";

function getWebsiteUrl(path: string, trailingSlash = true): string {
  const url = new URL(urlJoin(path, { trailingSlash }), WEBSITE_DOMAIN);
  return url.href;
}

export default getWebsiteUrl;
